// extracted by mini-css-extract-plugin
export default {"introduce":"index_introduce_OcMPw","wrapper":"index_wrapper_td9zA"};